import React, { useState, useEffect } from 'react';
import { Packages } from '@C/Utils';
import { authHeader } from '@H';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import ExistingPlans from './ExistingPlans';
import services from '@C/Admin/Packages/_utils/data';
import { ToggleSwitch } from '@C/FormElements';

let validityOptions = [];

const Plans = () => {
  const [packageName, setPackageName] = useState({
    validity_id: '',
    plan_type: '',
    price: '',
    plan_name: '',
    is_trial: false,
    is_onetime: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    getValidityPeriods();
  }, []);

  const getValidityPeriods = () => {
    services
      .getValidityPeriods()
      .then((response) => {
        const tmp = response.data.data;
        validityOptions = tmp.map((item) => ({
          value: item.uuid,
          label: `${item.days} days`,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPackageName((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleValidityChange = (e) => {
    setPackageName((prevState) => ({
      ...prevState,
      validity_id: e.value,
    }));
  };

  const handlePackageChange = (e) => {
    setPackageName((prevState) => ({
      ...prevState,
      plan_id: e?.value || '',
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const headers = authHeader(1);
    axios
      .post(
        `${process.env.API_URL}/subscription/subscription-plan/`,
        packageName,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Plan added successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setPackageName({
          plan_id: '',
          plan_type: '',
          price: '',
          plan_name: '',
        });
        setIsSubmitting(false);
        setUpdated((prev) => !prev);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message, {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table">
        <header>
          <h3> Add new plan </h3>
        </header>
        <main className="packages-container">
          <form className="full-width">
            <div className="input-wrapper with-label">
              <label>Plan name</label>
              <input
                type="text"
                onChange={handleChange}
                value={packageName.plan_name}
                name="plan_name"
              />
            </div>
            <div className="input-wrapper with-label">
              <label>Select the package :</label>
              <Packages
                handlePackageChange={handlePackageChange}
                value={packageName.plan_id}
              />
            </div>
            <div className="input-wrapper with-label">
              <label>Set price</label>
              <input
                type="text"
                onChange={handleChange}
                value={packageName.price}
                name="price"
              />
            </div>
            <div className="input-wrapper  toggle-element">
              <span className="label">Is this a trial plan?</span>
              <ToggleSwitch
                did={0}
                id="is_trial"
                name="is_trial"
                optionLabels={['Yes', 'No']}
                checked={packageName.is_trial}
                onChange={(e) => {
                  setPackageName((prevState) => ({
                    ...prevState,
                    is_trial: e.target.checked ? true : false,
                  }));
                }}
              />
            </div>
            <div className="input-wrapper  toggle-element">
              <span className="label">Is this a one-time plan?</span>
              <ToggleSwitch
                did={0}
                id="is_onetime"
                name="is_onetime"
                optionLabels={['Yes', 'No']}
                checked={packageName.is_onetime}
                onChange={(e) => {
                  setPackageName((prevState) => ({
                    ...prevState,
                    is_onetime: e.target.checked ? true : false,
                  }));
                }}
              />
            </div>
            <div className="input-wrapper with-label">
              <label>Select plan validity:</label>
              <Select
                name="sort_order"
                options={validityOptions}
                onChange={handleValidityChange}
                value={validityOptions.find(
                  (option) => option.value === packageName.validity_id,
                )}
              />
            </div>
            <div className="cta-wrapper">
              <button
                className="submit"
                type="submit"
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                {isSubmitting ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </main>
      </section>
      <ExistingPlans key={updated} />
    </>
  );
};

export { Plans };
